"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castagneto-carducci": {
    "0ea5fc06": [{
      "hkey": "41e5f283",
      "slug": "marina-di-castagneto-carducci",
      "name": "Marina di Castagneto Carducci",
      "primary": true,
      "skipSearch": false
    }],
    "marina-di-castagneto-donoratico": [{
      "hkey": "41e5f283",
      "slug": "marina-di-castagneto-carducci",
      "name": "Marina di Castagneto Carducci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castagneto-carducci"
    }]
  }
};
exports["default"] = _default;